import * as React from "react";
import { forwardRef } from "react";
const SvgBank = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.58366 0.833336L1.66699 5V6.66667H17.5003V5M13.3337 8.33334V14.1667H15.8337V8.33334M1.66699 18.3333H17.5003V15.8333H1.66699M8.33366 8.33334V14.1667H10.8337V8.33334M3.33366 8.33334V14.1667H5.83366V8.33334H3.33366Z", fill: "black" }));
const ForwardRef = forwardRef(SvgBank);
export default ForwardRef;
